module.exports = __webpack_public_path__ + "static/media/map-marker-division.82d1fc49.svg";